import { FormType } from '@gearbelt/global';
import dayjs from 'dayjs';
import { match } from 'ts-pattern';

import CheckIcon from '@/components/icons/check';
import FormChecklistIcon from '@/components/icons/form-checklist';
import WarningTriangleIcon from '@/components/icons/warning-triangle';
import { cn, getInitialsStyle, initials } from '@/lib/utils';

interface ListItemProps extends React.HTMLAttributes<HTMLDivElement> {
  formType: number;
  itemLabel?: string;
  itemCompletedAt?: Date;
  itemStatus?: string;
  itemContactName?: string;
  itemSubmittedByName?: string;
}

function ListItem({
  className,
  formType = 0,
  itemLabel = '',
  itemCompletedAt = new Date(),
  itemStatus = 'Created',
  itemContactName = '',
  itemSubmittedByName = '',
  ...props
}: ListItemProps) {
  return (
    <div
      className={cn('active:bg-grey-2 flex h-fit w-full cursor-pointer flex-col items-start space-y-[5px] rounded-[5px] bg-white p-2 pb-5', className)}
      {...props}>
      <div className="flex h-[35px] w-full flex-row items-start justify-between pb-1">
        <div className="flex h-[30px] w-full flex-row items-center justify-center space-x-[5px] p-0">
          {match(formType)
            .with(FormType.InspectionForm, () => <FormChecklistIcon size={30} />)
            .with(FormType.RepairForm, () => <FormChecklistIcon size={30} />)
            .with(FormType.ScheduleForm, () => <FormChecklistIcon size={30} />)
            .with(4, () => <WarningTriangleIcon size={30} className="text-default-red" />)
            .otherwise(() => (
              <FormChecklistIcon size={30} />
            ))}

          <div className="text-default-text h-[21px] w-full text-sm font-normal">{dayjs(itemCompletedAt).format('MMM DD, YYYY HH:mm')}</div>
        </div>
        <div className="bg-default-light-green flex h-[25px] w-[82px] flex-row items-center justify-center space-x-[2px] rounded-[5px] px-1 py-[2px]">
          <CheckIcon size={20} />
          <div className="h-[21px] w-full text-sm font-medium">{itemStatus}</div>
        </div>
      </div>
      <div className="flex h-fit w-full flex-row items-start gap-x-2.5 p-0">
        <div
          className={`flex h-[36px] w-[40px] flex-col items-center justify-center ${getInitialsStyle(initials(itemSubmittedByName || itemContactName))} rounded-full text-lg font-bold text-white`}>
          {initials(itemSubmittedByName || itemContactName)}
        </div>
        <div className="flex h-fit w-full min-w-0 flex-col items-start gap-y-1 p-0">
          <div className="text-default-text w-full truncate text-base font-bold">{itemLabel}</div>
          <div className="text-secondary-text text-sm font-normal">{itemSubmittedByName || itemContactName}</div>
        </div>
      </div>
    </div>
  );
}

export { ListItem };
